import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type {
    Curation,
    Brand,
    CurationImage,
    CurationZone,
    HydratedCurationModule,
    AdModule,
} from "~types/types";

const initialState: Curation = {
    id: "",
    title: "",
    description: "",
    brand: "" as Brand,
    path: "",
    theme: "",
    image: {} as CurationImage,
    zones: [] as CurationZone[],
};

const curationSlice = createSlice({
    name: "curation",
    initialState,
    reducers: {
        curationFetched(state, action: PayloadAction<Curation>) {
            Object.assign(state, action.payload);
        },
        updateModulesInZone(
            state,
            action: PayloadAction<{
                name: string;
                data: (HydratedCurationModule | AdModule)[];
                section: number;
            }>
        ) {
            const { name, data, section } = action.payload;
            const { zones } = state;
            const index = zones.findIndex((value) => value.name === name);

            if (state.zones[index].columns[section]) {
                state.zones[index].columns[section].modules = data;
            }
        },
    },
});

export const { curationFetched, updateModulesInZone } = curationSlice.actions;

export default curationSlice.reducer;
